const vibrate = (pattern = 18) => {
  if (typeof navigator === 'undefined') {
    return;
  }
  const fn = navigator.vibrate
    || navigator.webkitVibrate
    || navigator.mozVibrate
    || navigator.msVibrate;
  if (fn) {
    fn.call(navigator, pattern);
  }
};

export default vibrate;



// WEBPACK FOOTER //
// ./src/unit/vibrate.js